import React, { useEffect, useState } from 'react'

import { ProductListCount, ProductListPager } from '../..'
import { getNumberOfActiveFilters } from '../../../utils'
import { useMediaResize, useTranslation } from '../../../utils/providers'

import { MobileFilter } from '../ProductListFilter'
import DesktopFilter from './DesktopFilter'
import Grid from './Grid.js'

function ProductGrid({
  aggregations,
  products,
  totalProductCount,
  queryParams,
  submitForms,
  resetAllFilters,
  categoryData,
  searchData,
}) {
  const { t } = useTranslation()
  const { breakpoints, initialDevice } = useMediaResize()
  const [isMobile, setMobile] = useState(initialDevice === 'mobile')

  useEffect(() => {
    setMobile(breakpoints.downMD)
  }, [breakpoints.downMD])

  const numberOfActiveFilters = getNumberOfActiveFilters({ aggregations })

  const filterProps = {
    aggregations,
    totalProductCount,
    numberOfActiveFilters,
    queryParams,
    submitForms,
    resetAllFilters,
    categoryUrls: categoryData?.url,
    searchData,
  }

  return (
    <div className="container my-3" id="product_listing">
      <aside aria-label={t('PRODUCT_LIST_FILTER_HEADING')}>
        {isMobile ? (
          <MobileFilter {...filterProps} />
        ) : (
          <DesktopFilter {...filterProps} />
        )}
      </aside>
      <ProductListCount className="p-0 mx-3 my-4" count={totalProductCount} />
      <Grid products={products} />
      <ProductListPager
        className="my-3"
        submitForms={submitForms}
        totalProductCount={totalProductCount}
        queryParams={queryParams}
      />
    </div>
  )
}

export default ProductGrid
